import { render } from "./PlaceholderModule.vue?vue&type=template&id=20caea32"
const script = {}

import exportComponent from "/home/krists/Documents/git/bomb-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__